import React from 'react'

export const Title = ({ children }) => {
  return (
    <header className="major">
      <h2>{children}</h2>
    </header>
  )
}

export const Body = ({ children }) => {
  return <p>{children}</p>
}

export const Action = ({ title, link }) => {
  return (
    <ul className="actions">
      <li>
        <a href={link} className="button">
          {title}
        </a>
      </li>
    </ul>
  )
}

const Section = ({ id, children }) => {
  return <section id={id}>{children}</section>
}

export default Section
